export default __webpack_public_path__ + "static/media/r_puntos_go_logo_white.bbad6b5e.svg";